import React from 'react';
import './message.css';
import { Icon } from '../../../components/icon';
import { Paragraph } from '../../../components/paragraph';
import { IconButton } from '../../../components/icon-button';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Message = props => {
    const { message, modalVisible, submitResponse } = props;

    const senderType = message.senderPhoto;

    const messageClasses = classNames({
        message__message: true,
        'message__message--media': senderType === 'Media',
        'message__message--whip':
            senderType === 'Whip' || senderType === 'Staff member',
        'message__message--business': senderType === 'Business',
        'message__message--public':
            senderType === 'Group' || senderType === 'campaign',
    });

    return (
        <div className="message">
            <div className={messageClasses}>
                <div className="message__header">
                    <Icon iconName="sender" size="x-small" />
                    <Paragraph
                        colorScheme="light"
                        fontSize="large"
                        fontWeight="bold"
                        withIndent
                        withSpacing={false}
                    >
                        {message.sender}
                    </Paragraph>
                </div>
                <Paragraph withSpacing={false}>{message.prompt}</Paragraph>
            </div>
            {message &&
                Object.values(message.responses).map((response, index) => {
                    const scores = {
                        party: response.score_party,
                        voters: response.score_local,
                        media: response.score_media,
                    };
                    return (
                        <div className="message__response" key={index}>
                            <Paragraph withSpacing={false}>
                                {response.response}
                            </Paragraph>
                            <IconButton
                                onClick={() =>
                                    submitResponse(scores, response.feedback)
                                }
                                iconName="arrow"
                                size="small"
                                type="main"
                                withSpacing={true}
                                isDisabled={modalVisible}
                                altText="choose response"
                            />
                        </div>
                    );
                })}
        </div>
    );
};

Message.defaultProps = {
    modalVisible: false,
};

Message.propTypes = {
    message: PropTypes.object.isRequired,
    modalVisible: PropTypes.bool,
    submitResponse: PropTypes.func.isRequired,
};

export { Message };
